import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import InfoButton from '../InfoButton/InfoButton.tsx';

interface CustomInstructionSectionProps {
    label: React.ReactNode;
    tooltipId: string;
    tooltipContent: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    maxLength?: number;
}
const CustomInstructionSection: React.FC<CustomInstructionSectionProps> = (
    {
        label,
        tooltipId,
        tooltipContent,
        value,
        onChange,
        maxLength,
    }) => {
    return (
        <div className="flex flex-col space-y-2 w-full overflow-x-hidden overflow-y-hidden">
            <div className="flex items-center space-x-1">
                <span className="text-sm">{label}</span>
                <InfoButton tooltipId={tooltipId} tooltipContent={tooltipContent} direction={'bottom'} />
            </div>
            <div className="w-full overflow-hidden rounded-md text-sm">
                <TextareaAutosize
                    value={value}
                    onChange={onChange}
                    minRows={4}
                    maxRows={7}
                    maxLength={maxLength}
                    className="w-full p-2 bg-neutral-100 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-100 rounded-md resize-none box-border"
                    placeholder="Give the AI some details to keep in mind..."
                />
                {maxLength && (
                    <div className="text-xs text-right mt-0.5 mr-1 text-neutral-500 dark:text-neutral-400">
                        {value.length} / {maxLength}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomInstructionSection;